jQuery( function( $ ) {
	const $mobileButton = $( 'button#mobile-button' ),
		$acMenu = $( '.ac-nav-collapse' );

	$mobileButton.on( 'click', function() {
		$acMenu.toggleClass( 'mobile-open' );
	} );

	$( '.nav-menu > .menu-item-has-children' ).append( '<div class="toggle-sub-menu"><i class="fa fa-plus"></i></div>' );

	$( '.toggle-sub-menu' ).on( 'click', function() {
		$( this ).siblings( '.sub-menu' ).toggleClass( 'show-sub-menu' );
		$( this ).toggleClass( 'sub-menu-open' );
	} );

	$( '#search-toggle' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );
	} );
} );
